import { useCallback, useState, useMemo } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTheme } from '@mui/material/styles';
import { Send, Verified, Close } from '@mui/icons-material';
import axiosInstance from '../../../api/axios';
import OtpInput from 'react-otp-input';
import { notifySuccess, notifyError } from "../toast/ToastFunc";

const TransactionOTPDialog = (props) => {
  const { onVerified, transferLoading, setTransferLoading, showTransactionOTPDialog, setShowTransactionOTPDialog, otpSource } = props;
  const [otp, setOtp] = useState('');
  const [showWarning, setShowWarning] = useState(true);

  const theme = useTheme();

  const buttonTheme = useMemo(() => {
    return {
      color: 'white', backgroundColor: theme.mainColor, fontSize: 15, fontWeight: "bold", borderRadius: 2,
      '&:hover': {
        backgroundColor: '#b30000', color: 'white', fontSize: 15, fontWeight: "bold", borderRadius: 2
      },
    }
  }, [theme.mainColor]);

  const closeDialogBox = useCallback(() => {
    setShowTransactionOTPDialog(false);
    setOtp('');
  }, [setShowTransactionOTPDialog]);

  const generateOTP = useCallback(async () => {
    setTransferLoading(true);
    try {
      const response = await axiosInstance.post('/auth/generate-otp', {
        "otp_source": otpSource,
      });
      setShowWarning(false);
      notifySuccess(response?.data?.message || "Success");
    } catch (error) {
      notifyError(error.message || "Something went wrong");
    } finally {
      setTransferLoading(false);
    }
  }, [otpSource, setTransferLoading]);

  // const verifyOTP = useCallback(async () => {
  //   onVerified(otp, otpSource);
  //   setOtp('');
  // }, [onVerified, otp, otpSource]);

  // const verifyOTP = useCallback(async () => {
  //   setTransferLoading(true);
  //   try {
  //     const response = await axiosInstance.post('/auth/verify-otp', {
  //       "otp": otp,
  //       "otp_source": otpSource,
  //     });
  //     setShowTransactionOTPDialog(false);
  //     notifySuccess(response?.data?.message || "Success");
  //     onVerified();
  //   } catch (error) {
  //     notifyError(error.message || "Something went wrong");
  //   } finally {
  //     setTransferLoading(false);
  //   }
  // }, [onVerified, otp, otpSource, setShowTransactionOTPDialog]);

  return (
    <Dialog open={showTransactionOTPDialog}>
      <DialogTitle sx={{ fontSize: 23, mb: 2 }}>OTP Verification</DialogTitle>
      <DialogContent>
        {showWarning ? (
          <Typography sx={{ fontSize: 20 }}>Please verify your details before proceeding.</Typography>
        ) : (
          <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '26px',
          }}>
            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              renderInput={(props) => <input {...props} />}
              shouldAutoFocus
              inputStyle={{
                width: '1em', height: '1.5em', margin: '0 0.5em', fontSize: '2rem',
                textAlign: 'center', borderRadius: '8px', border: '1px solid #990000'
              }}
            />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        {showWarning ? (
          <>
            <Button onClick={() => closeDialogBox()} startIcon={<Close />} sx={{ mr: 1, color: theme.mainColor }}>Cancel</Button>
            <LoadingButton
              variant="contained"
              onClick={() => generateOTP()}
              loadingPosition="start"
              startIcon={<Send />}
              disabled={transferLoading}
              loading={transferLoading}
              sx={{ ...buttonTheme }}
            >
              {transferLoading ? "Sending" : "Send OTP"}
            </LoadingButton>
          </>
        ) : (
          <>
            <Button onClick={() => closeDialogBox()} startIcon={<Close />} sx={{ mr: 1, color: theme.mainColor }}>Cancel</Button>
            <LoadingButton
              variant="contained"
              onClick={() => onVerified(otp, otpSource)}
              loadingPosition="start"
              startIcon={<Verified />}
              disabled={otp.length !== 6 || transferLoading}
              loading={transferLoading}
              sx={{ ...buttonTheme }}
            >
              {transferLoading ? "Verifying" : "Verify OTP"}
            </LoadingButton>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default TransactionOTPDialog;